import api from './AxiosInstance';

export class ListFournisService {



  getAllListFournis = async () => {
    try {
      const response = await api.get(`/Fournisseur/list`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getOneListFournis = async (fournisseurId) => {
    try {
      const response = await api.get(`/Fournisseur/${fournisseurId}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  updateListFournis = async (payload) => {
    try {


      const response = await api.put(`/Fournisseur/update`, payload)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de prestation :', error);
      throw error;
    }
  };

  uploadFournFiles = async (numfourn, files) => {
    try {
      const formData = new FormData();
      files.forEach((file) => {
        formData.append('files', file);
      });

      const response = await api.post(`/Ged/uploadFiles/Fourn/${numfourn}`, formData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'upload des fichiers fournisseur :', error);
      throw error;
    }
  };

  getAllFournFiles = async (numfourn) => {
    try {
      const response = await api.get(`/Ged/Fournisseur/list/${numfourn}`);
      return response.data;
    } catch (error) {
      try {
        const fallbackResponse = await api.get(`/Ged/Fournisseur/list/${numfourn}`);
        return fallbackResponse.data;
      } catch (fallbackError) {
        console.error('Erreur lors de la recuperation des fichiers fournisseur :', fallbackError);
        throw fallbackError;
      }
    }
  };


  downloadFileFourn = async (fileId) => {
    try {
      const response = await api.get(`/Ged/downloadFile/Fourn/${fileId}`, {
        responseType: "blob",
      });
      return response;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  deleteFournFile = async (fileId) => {
    try {
      const response = await api.delete(`/Ged/deleteFileFournGed/${fileId}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression du fichier :', error);
      throw error;
    }
  };

  addListFournis = async (newPrestation) => {
    try {


      const response = await api.post(`/Benef/typeBenef/add`, newPrestation)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };


  deleteListFournis = async (prestationId) => {
    try {

      const response = await api.delete(`/Benef/typeBenef/delete/${prestationId}`)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de prestation :', error);
      throw error;
    }
  };


}


